<template>
  <div class="change-password-success-confirm">
    <section class="section">
      <div class="container">
        <div class="columns change-pass-flex-row">
          <div v-if="$mq.desktop" class="column column-success">
            <svg-icon name="success" width="250" height="150"></svg-icon>
          </div>
          <div class="column is-narrow">
            <div class="success-change-box">
              <h2 v-translate :class="$mq.phone ? 'heading-3': 'heading-2'">Success!</h2>
              <p :class="$mq.phone ? 'paragraph-m' : 'paragraph-l'">
                {{ message || defaultMessage }}
              </p>
              <a class="button is-primary" @click="redirectToDefaultTargetRouteUrl">{{ backToByRouteNameTranslated[validPreviousState.name] }}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import 'top20common/distribution/icons/success';

import RedirectsService from 'top20common/distribution/services/redirects';
import translated from 'top20common/distribution/services/translated-data';
import {mapGetters} from 'vuex';

export default {
  props: {
    message: String
  },
  computed: {
    ...mapGetters(['validPreviousState']),
    backToByRouteNameTranslated() {
      return translated.backToByRouteNameTranslated(this);
    },
    defaultMessage() {
      return this.$gettext('You have successfully updated your password. Now you can login.');
    }
  },
  methods: {
    redirectToDefaultTargetRouteUrl() {
      window.location.href = RedirectsService.getUrlWithoutLanguage(this.validPreviousState.path);
    }
  }
};
</script>

<style scoped lang="scss">
@import '~VariablesStyles';

.section {
  padding: 0;
  width: 100%;
}
.change-pass-flex-row {
  justify-content: center;
}

.success-change-box {
  max-width: 320px;
  margin: 0 auto;
}

h2 {
  margin-bottom: 14px;
}

.button {
  margin-top: 25px;
}

.column-success {
  text-align: right;
  padding: 0;
  min-width: 255px;
}

.change-password-success-confirm {
  width: 100%;
  height: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
}

@media screen and (min-width: $tablet) {
  .success-change-box {
    margin: 0;
  }
}
</style>
